<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "org_setup_reminder_msg_3" | translate }}</h2>
            </div>
            <div class="panel-left-btn">
            </div>
        </header>
        <div class="eod-panel-body-with-footer">
            
            <div class="block mt-2">
                <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>{{ "org_setup_reminder_msg_1" | translate }}</span>
                </h6>

                 <h6 class="info-text">
                    <i class="fas fa-exclamation-circle eod-text-danger"></i>
                    <span>{{ "org_setup_reminder_msg_2" | translate }}</span>
                </h6>
                
            </div>

            <div class="block mt-2">
                <div class="radio-button mb-2 border-0 pb-0">
                    <input type="radio" 
                           name="orgSetupReminderOption1" 
                           class="align-middle svg-20 cursor-pointer mt-1"
                           [value]="ReminderoptionEnum.EnterNumberOfDays"
                           [checked]="selectedReminderOption === ReminderoptionEnum.EnterNumberOfDays"
                           (change)="onReminderOptionChange(ReminderoptionEnum.EnterNumberOfDays)">
                    <label class="" for="orgSetupReminderOption1">
                        <span class="eod-text-secondary">{{ "remind_me_after" | translate }}</span>
                        <span [style.pointer-events]="selectedReminderOption !== ReminderoptionEnum.EnterNumberOfDays ? 'none' : 'auto'"
                              [style.opacity]="selectedReminderOption !== ReminderoptionEnum.EnterNumberOfDays ? '0.5' : '1'">
                            <select class="border p-1 min-w-5em mx-2" 
                                    [(ngModel)]="numberOfDays"
                                    (ngModelChange)="onDaysChange($event)"
                                    [disabled]="selectedReminderOption !== ReminderoptionEnum.EnterNumberOfDays">
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                            </select>
                        </span>
                        <span class="eod-text-secondary">{{ "days" | translate }}</span>
                    </label>
                </div>
                <div class="d-flex align-items-center mb-3">
                    <div class="radio-button border-0 p-0 m-0 mt-1">
                        <input type="radio" 
                               name="orgSetupReminderOption2" 
                               class="align-middle svg-20 cursor-pointer" 
                               id="fReportDate1"
                               [value]="ReminderoptionEnum.SelectDate"
                               [checked]="selectedReminderOption === ReminderoptionEnum.SelectDate"
                               (change)="onReminderOptionChange(ReminderoptionEnum.SelectDate)">
                        <label class="d-flex align-items-center w-100pc" for="orgSetupReminderOption2">{{ "remind_me_on" | translate }} </label>
                    </div>
                    <div class="input-group max-w-10em max-h-2_2em ml-2" 
                         [style.pointer-events]="selectedReminderOption !== ReminderoptionEnum.SelectDate ? 'none' : 'auto'"
                         [style.opacity]="selectedReminderOption !== ReminderoptionEnum.SelectDate ? '0.5' : '1'">
                        <input class="form-control has-value" 
                               id="fReportDate2" 
                               #fReportDate 
                               name="fromDate"
                               [(ngModel)]="selectedDate"
                               (ngModelChange)="onDateChange($event)"
                               [disabled]="selectedReminderOption !== ReminderoptionEnum.SelectDate" />
                        <app-calendar-icon></app-calendar-icon>
                    </div>
                </div>

                <div class="radio-button">
                    <input type="radio" 
                           name="orgSetupReminderOption3" 
                           class="align-middle svg-20 cursor-pointer"
                           [value]="ReminderoptionEnum.NoReminder"
                           [checked]="selectedReminderOption === ReminderoptionEnum.NoReminder"
                           (change)="onReminderOptionChange(ReminderoptionEnum.NoReminder)">
                    <label class="" for="orgSetupReminderOption3">
                        {{ "dont_remind_me" | translate }}
                    </label>
                </div>
            </div>

        </div>
        <footer class="mt-auto py-1 d-flex justify-content-center align-items-center gap-2 height-60px">
            <button type="button" class="btn eod-btn-outline-warning" (click)="onCloseClick()">
                {{ "change_password_cancel" | translate }}
            </button>
            <button type="button" class="btn eod-btn-primary" (click)="onClick()">
                {{ panelData?.btnClickText }}
            </button>
            <button type="button" 
                    class="btn eod-btn-primary" 
                    [class.disabled]="!isSaveButtonEnabled"
                    (click)="saveReminderConfiguration()">
                {{ "label_save" | translate }}
            </button>
        </footer>
    </div>
</div>